import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

export const ndtSnackBarAnimations: {
  readonly snackBarState: AnimationTriggerMetadata;
} = {
  snackBarState: trigger('state', [
    state(
      'void, hidden',
      style({
        transform: 'scale(0.5)',
        opacity: 0,
      }),
    ),
    state(
      'visible',
      style({
        transform: 'scale(1)',
        opacity: 1,
      }),
    ),
    transition('* => visible', animate('500ms cubic-bezier(0, 0, 0.2, 1)')),
    transition(
      '* => void, * => hidden',
      animate(
        '200ms cubic-bezier(0.4, 0.0, 1, 1)',
        style({
          transform: 'scale(1.10)',
          opacity: 0,
        }),
      ),
    ),
  ]),
};
